/* eslint no-shadow: ["error", { "allow": ["state"] }] */
/* eslint no-param-reassign: ["error", { "props": false }] */
import Vue from 'vue';
import * as mTypes from 'store/mutation-types';
import { getApiPath } from '../../store-helpers';

const state = {
  pricingrules: [],
  error: null,
};

const getters = {
  pricingrules: state => state.pricingrules,
  error: state => state.error,
};

const actions = {
  fetch({ commit }, payload) {
    return Vue.http.get(`${getApiPath(payload.user)}/products/${payload.id}/pricingrules`)
      .then((response) => {
        commit(mTypes.DATA_FETCHED, response);
      });
  },
};

const mutations = {
  [mTypes.DATA_FETCHED](state, pricingrules) {
    state.pricingrules = [];
    if (pricingrules.data.items) {
      pricingrules.data.items.forEach((el) => {
        state.pricingrules.push(el);
      });
    }
    state.error = null;
  },
  [mTypes.REMOVE_DATA](state, pricingruleId) {
    const index = state.pricingrules.findIndex(obj => obj.id === pricingruleId);
    state.pricingrules.splice(index, 1);
  },
  [mTypes.CLEAR_STATE](state) {
    state.pricingrules = [];
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/pricingrules/pricingrules.js